var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyzedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 104,
    viewBox: "0 0 304 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1773_37059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1216 102C1216 102 296.758 102 195.5 102H178H152C149.791 102 148 100.209 148 98V95.7262C148 93.517 146.209 91.7262 144 91.7262H100V95.0711H76V91.7262H31.6603C29.4512 91.7262 27.6603 93.517 27.6603 95.7262V98C27.6603 100.209 25.8695 102 23.6603 102H0M141.109 39.1939V84.7966M34.653 84.7967V32.9497C34.653 29.1269 37.7421 26.0208 41.5441 26.0208H107.106M141.109 102H34.653M95.3939 46.1807H116.999M95.3939 57.6134H129.783M95.3939 69.2782H129.783M95.3939 80.7097H129.783M60.9873 80.3888V63.5652H71.0264V80.3888M46.6053 80.3884V62.8755H43.6165V57.6274L65.9392 41.1336M85.3419 80.3884V62.8755H88.3308V57.6274L66.0081 41.1336M135.103 11.9726L126.406 21.0023L122.612 17.2003L118.819 21.0023L126.406 28.7963L138.897 15.8696L135.103 11.9726ZM145.59 19.8237C145.59 29.1151 138.099 36.6473 128.858 36.6473C119.617 36.6473 112.126 29.1151 112.126 19.8237C112.126 10.5322 119.617 3 128.858 3C138.099 3 145.59 10.5322 145.59 19.8237Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_37059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzedIcon);
export default __webpack_public_path__ + "static/media/analyzed-icon.8ed8057b.svg";
export { ForwardRef as ReactComponent };